import * as angular from 'angular';
import {DataHubService} from "./DataHubModule";
import {UserStorageDto} from "../model/UserStorageDto";
import {ConfigService} from "./ConfigModule";

export class UserStorageService {
    store = new Array<UserStorageDto>();

    constructor(private $dataHub: DataHubService, $config: ConfigService, $rootScope: ng.IRootScopeService) {
        $dataHub.on('userStorageUpdated', this.userStorageUpdated);
        $dataHub.on('userStorageRemoved', this.userStorageRemoved);

        $dataHub.onConnected(this.reload);

        $config.onLogin(this.reload);
    }

    get = <T>(key: string): T | boolean => {
        let storage = this.store.filter(x => x.key === key)[0];
        if (!storage) return null;
        if (storage.value == null) return null;
        return JSON.parse(storage.value);
    };
    set = <T>(key: string, value: T): void => {
        this.$dataHub.invoke('userStorageSet', key, JSON.stringify(value));
    };
    remove = (key: string): void => {
        this.$dataHub.invoke('userStorageRemove', key);
    };

    userStorageUpdated = (entity) => this.store.merge(entity, x => x.key);

    userStorageRemoved = entity => this.store.remove(entity, x => x.key);

    private reload = () => {
        if(!this.$dataHub.isConnected) return;
        this.store = [];
        this.$dataHub.invoke('userStorageQuery');

        this.set("test","hello there general kenobi");
    }

}

export default angular.module('services.userStorage', [])
    .service('$userStorage', UserStorageService)
    .name;
